module.exports = __webpack_public_path__ + "band_6.8fbade9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/band_6.png
// module id = YmUE
// module chunks = 0